import React from "react";

export default function Alert({ color = "#424242", iconColor = "#fff", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      {...restProps}
    >
      <g fill="none" fillRule="evenodd">
        <path fill={color} d="M5 0h6l5 5v6l-5 5H5l-5-5V5z" />
        <path
          fill={iconColor}
          d="M8.91 9.83h-1.6L7.06 4h2.103L8.91 9.83zM7 11.646c0-.14.026-.271.08-.392a.9.9 0 0 1 .225-.314c.097-.087.213-.157.345-.208.133-.05.282-.076.446-.076.164 0 .312.026.445.076.133.051.248.12.346.208a.9.9 0 0 1 .225.314c.053.121.08.252.08.392 0 .141-.027.272-.08.393a.9.9 0 0 1-.225.314 1.096 1.096 0 0 1-.346.208c-.133.05-.281.076-.445.076-.164 0-.313-.026-.446-.076a1.096 1.096 0 0 1-.345-.208.9.9 0 0 1-.226-.314.972.972 0 0 1-.079-.393z"
        />
      </g>
    </svg>
  );
}
